import { render, staticRenderFns } from "./TotalSale.vue?vue&type=template&id=5ff9f464&scoped=true&"
import script from "./TotalSale.vue?vue&type=script&lang=js&"
export * from "./TotalSale.vue?vue&type=script&lang=js&"
import style0 from "./TotalSale.vue?vue&type=style&index=0&id=5ff9f464&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff9f464",
  null
  
)

export default component.exports